import * as tmpServicesSDK from '@tmp-services/sdk';

// clients
export import SearchClient = tmpServicesSDK.RoleLibraryModule.SearchClient;
export import AutoSuggestDocument = tmpServicesSDK.RoleLibraryModule.AutoSuggestDocument;
export import JobTaxonomyV2Client = tmpServicesSDK.RoleLibraryModule.JobTaxonomyV2Client;
export import JobTaxonomyType = tmpServicesSDK.RoleLibraryModule.JobTaxonomyType;
export import TaxonomicRank = tmpServicesSDK.RoleLibraryModule.TaxonomicRank;
export import UserCareerRole = tmpServicesSDK.RoleLibraryModule.UserCareerRole;
export import Role = tmpServicesSDK.RoleLibraryModule.Role;
export import RoleResponse = tmpServicesSDK.RoleLibraryModule.RoleResponse;
export import RoleSkill = tmpServicesSDK.RoleLibraryModule.RoleSkill;
export import Qualification = tmpServicesSDK.RoleLibraryModule.Qualification;
export import Responsibility = tmpServicesSDK.RoleLibraryModule.Responsibility;
export import CapabilityResponse = tmpServicesSDK.RoleLibraryModule.CapabilityResponse;
export import CategorizedSkillResponse = tmpServicesSDK.RoleLibraryModule.CategorizedSkillResponse;
export import Skill = tmpServicesSDK.RoleLibraryModule.Skill;
export import RoleProperty = tmpServicesSDK.RoleLibraryModule.RoleProperty;
